import classNames from 'clsx';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import BackButton from '@swf/components/StarsModal/components/BackButton';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import { call } from '@swf/core/api/embedded';
import useFromEvent from '@swf/core/hooks/useFromEvent';
import useScreenSize from '@swf/core/hooks/useScreenSize';
import { select } from '@swf/core/store';
import { mobileBreakpoint } from '@swf/core/utils';

import styles from './View.scss';

export interface Props {
  title?: React.ReactNode;
  nowrap?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const View: React.FC<Props> = ({ title, nowrap, children, className }) => {
  const history = useHistory();
  const fromEvent = useFromEvent();
  const { greaterThan } = useScreenSize();
  const smallScreen = !greaterThan(mobileBreakpoint);
  const isEmbedded = useSelector(select.site.isEmbedded);

  useEffect(() => {
    if (isEmbedded) {
      fromEvent(document, 'starsready').subscribe(() => {
        call(['app', 'setLoading'], false);
      });
    }
  }, [isEmbedded, fromEvent]);

  return (
    <>
      {title && !isEmbedded && (
        <header className={classNames(styles.header, { [styles.fixedHeader]: !nowrap })}>
          {smallScreen && history.length > 1 && <BackButton onClick={() => history.replace('.')} />}
          <h1>{title}</h1>
          {smallScreen && history.length > 1 && <CloseButton />}
        </header>
      )}
      {nowrap ? (
        children
      ) : (
        <section
          className={classNames(styles.section, className, {
            [styles.sectionEmbeddedAccount]: isEmbedded
          })}
        >
          {children}
        </section>
      )}
    </>
  );
};

export default View;
